import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Jätka ostuga külalisena

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka ostoksia vieraana

  <span style="color:#85c1dc;">**RU:**</span>
  Продолжить покупки в качестве гостя
*/
/* @__NO_SIDE_EFFECTS__ */
const m588 = msg(
  mf`Jätka ostuga külalisena`,
  mf`Jatka ostoksia vieraana`,
  mf`Продолжить покупки в качестве гостя`,
)

export { m588 as 'w.basket.continue_as_guest' }